import { b2cPolicies } from '../../../../auth-config';
import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import * as identityStore from '@core/identity';
import * as coreStore from '@core/store';
import { environment } from '@env/environment';
import { Store, select } from '@ngrx/store';
import { filter, map } from 'rxjs';

@Injectable()
export class AuthService {
  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    private store: Store
  ) {
    this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS))
      .subscribe(() => {
        this.updateAccountInfo();
      });

    this.msalBroadcastService.inProgress$
      .pipe(filter((status: InteractionStatus) => status === InteractionStatus.None))
      .subscribe(() => {
        this.updateAccountInfo();
      });
  }

  public logout() {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '',
    });
  }

  public login() {
    this.msalService.loginRedirect().subscribe(() => {});
  }

  private updateAccountInfo() {
    this.store.dispatch(identityStore.fetchIdentityAction());
  }

  public resetPassword() {
    const editProfileFlowRequest: RedirectRequest = {
      scopes: ['openid'],
      authority: b2cPolicies.authorities.editProfile.authority,
    };
    this.msalService.loginRedirect(editProfileFlowRequest);
  }

  public getGroups() {
    return this.store.pipe(
      select(identityStore.selectIdentityAccount(coreStore.selectIdentityState)),
      map(accountInfo => (accountInfo?.idTokenClaims?.groups as string[]) ?? []),
      map(groups => groups.filter(x => x.startsWith(environment.aadGroupPrefix)))
    );
  }

  public getRoles() {
    return this.store.pipe(
      select(identityStore.selectIdentityAccount(coreStore.selectIdentityState)),
      map(accountInfo => accountInfo?.idTokenClaims?.roles ?? [])
    );
  }

  public getAccount() {
    return this.store.select(identityStore.selectIdentityAccount(coreStore.selectIdentityState));
  }
}
